import { amountToDisplayValue } from '@billy/design-system'
import { Typography } from '@shinetools/lumen-react'
import { colors } from '@shinetools/lumen-tokens/web/colors'
import { ReactElement } from 'react'

import { EMPTY_VALUE_PLACEHOLDER } from '../../../../constants/emptyValuePlaceholder'

interface BalanceSheetAmountProps {
  bold?: boolean
  /** Renders in a muted color, used for account rows in the detailed view. Negative values stay red. */
  subdued?: boolean
  value?: number
}

const getAmountColor = (value: number | undefined, subdued: boolean) => {
  if (value !== undefined && value < 0) {
    return colors.content.danger.bold
  }

  return subdued ? colors.content.neutral.medium : undefined
}

export const BalanceSheetAmount = ({ bold = false, subdued = false, value }: BalanceSheetAmountProps): ReactElement => (
  <Typography.Text color={getAmountColor(value, subdued)} weight={bold ? 'semibold' : 'regular'}>
    {value === undefined ? EMPTY_VALUE_PLACEHOLDER : amountToDisplayValue(value)}
  </Typography.Text>
)
